import styled from 'styled-components';

import Icon from '@klv/atoms/icon';
import Typography from '@klv/atoms/typography';
import Grid from '@klv/utils/grid';


export const StyledGrid = styled(Grid)`
  grid-template-rows: min-content min-content min-content;
`;

export const InHeroContainer = styled.div`
  order: -1;
  ${({ theme }) => theme.screenSize.s768.mediaQuery} {
    order: unset;
  }
`;

export const StyledHeadline = styled(Typography)<{ inHero?: boolean; }>`
  ${({ theme, inHero }) => `
    color: var(--color-white);
    margin-bottom: 1.5rem;
    ${inHero ? 'font-size: 2.4rem;' : ''}
  `}
`;

export const ModalContent = styled.div`
  grid-column: 1 / -1;
  grid-row: 2;
  ${({ theme }) => (`
    ${theme.screenSize.s768.mediaQuery} {
      grid-column: 2 / -2;
    }    
    ${theme.screenSize.s1024.mediaQuery}{
      grid-column: 3 / -3;
    }
    ${theme.screenSize.s1366.mediaQuery}{
      grid-column: -7 / -3;
      grid-row: 1;
    }
  `)
}
`;

export const LogoWrapper = styled.div`
  grid-column: 1 / -1;
  max-width: 12.5rem;
  grid-row: 1;
  margin-top: 4rem;
  margin-bottom: 5rem;
  ${({ theme }) => theme.screenSize.s768.mediaQuery}{
    grid-column: 2 / -2;
  }
  ${({ theme }) => theme.screenSize.s1024.mediaQuery}{
    grid-column: 3 / -3;
  }
  ${({ theme }) => theme.screenSize.s1366.mediaQuery}{
    margin-top: 0;
    grid-column: 3 / 5;
    grid-row: 1;
  }
`;

export const ParagraphContent = styled(Typography)`
  margin-bottom: 2.5rem;
`;

export const FormArea = styled.div`
  width: 100%;
  overflow-y: auto;
  padding:0 .2rem;
`;

export const KlaviyoLogo = styled(Icon)`
  color: var(--color-white);
  width: 100%;
  height: auto !important;
`;

export const BottomTriangle = styled.div`
  border-right: solid 10rem var(--color-poppy);
  border-top: solid transparent 10rem;
  height: 10rem;
  position: absolute;
  bottom: 0;
  right: 0;
  display: none;
  ${({ theme }) => theme.screenSize.s768.mediaQuery}{
    display: block;
  }
`;
